
import { isIOS } from './browser';

let appStoken = '';

const generatorCallbackName = () => {
  return `callback${Date.now()}`;
};

const callIOSH5Bridge = (methodName, params, resolve) => {
  const callback = generatorCallbackName();
  window[callback] = (data) => {
    resolve(data);
  };
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.NativeMethod &&
    window.webkit.messageHandlers.NativeMethod.postMessage
  ) {
    window.webkit.messageHandlers.NativeMethod.postMessage(
      JSON.stringify({
        methodName,
        ...params,
        callback,
      }),
    );
  }
};

const callAndroidH5Bridge = (methodName, params, needFunCallback, resolve) => { // 参数暂时不用，后续注意兼容
  const callback = generatorCallbackName();
  window[callback] = (data) => {
    resolve(data);
  };
  if (window.tf56 && window.tf56[methodName]) {
    if (needFunCallback) {
      window.tf56[methodName](callback);
    } else {
      resolve(window.tf56[methodName]());
    }
  }
};

/**
 * 去除原生title
*/
export function hideH5Title(obj) {
  try{
    if(!isIOS()){
      window.tf56.hideH5Title();
    }
  }catch(e){
    console.log(e);
  }

};
/**
 * 显示原生btn
*/
export function showBackBtn(isTrue) {
  try{
    if(!isIOS()){
      window.tf56.showBackBtn(isTrue);
    }
  }catch(e){
    console.log(e);
  }

};

/**
 * 关闭原生页面
*/
export function dissmissWebView() {
  try{
    return isIOS() ?
    window.webkit.messageHandlers.NativeMethod.postMessage(JSON.stringify({ methodName: 'popVC', text: '', callback: '' })) :
    window.tf56 && window.tf56.finishPage();
  }catch(e){
    console.log(e);
  }

};
export function closeWebView(){
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('finishPage', {}, resolve)
      })
       // window.webkit.messageHandlers.NativeMethod.postMessage(JSON.stringify({ methodName: 'finishPage', text: '', callback: '' }))
      : window.tf56 && window.tf56.finishPage();
  }catch(e){
    console.log(e);
  }
};

/**
 * 设置title
*/
export function setTitle(title) {
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('showH5Title', {title}, resolve)
      })
        // window.webkit.messageHandlers.NativeMethod.postMessage(JSON.stringify({ methodName: 'finishPage', text: '', callback: '' }))
      : window.tf56 && window.tf56.showH5Title(title);
  }catch(e){
    console.log(e);
  }

};

// 个人信息
export function jumpToUserInfo(){
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('jumpToUserInfo', {}, resolve)
      })
       // window.webkit.messageHandlers.NativeMethod.postMessage(JSON.stringify({ methodName: 'finishPage', text: '', callback: '' }))
      : window.tf56 && window.tf56.jumpToUserInfo();
  }catch(e){
    console.log(e);
  }
};

// 认证信息
export function jumpToAuthInfo(){
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('jumpToAuthInfo', {}, resolve)
      })
      : window.tf56 && window.tf56.jumpToAuthInfo();
  }catch(e){
    console.log(e);
  }
};

// 常用地址
export function jumpToCommonAddress(){
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('jumpToCommonAddress', {}, resolve)
      })
      : window.tf56 && window.tf56.jumpToCommonAddress();
  }catch(e){
    console.log(e);
  }
};

// 合同管理
export function jumpToContract(){
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('jumpToContract', {}, resolve)
      })
      : window.tf56 && window.tf56.jumpToContract();
  }catch(e){
    console.log(e);
  }
};

//账户与安全 jumpToAccountSecurity
export function jumpToAccountSecurity(){
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('jumpToAccountSecurity', {}, resolve)
      })
      : window.tf56 && window.tf56.jumpToAccountSecurity();
  }catch(e){
    console.log(e);
  }
};

//TMS司机注册签署改造，原生交互跳转
export function jumpToTMSPage(signStatus){
  try{
    return isIOS() ?
      new Promise((resolve) => {
        callIOSH5Bridge('jumpToTMSPage', {signStatus}, resolve)
      })
      : window.tf56 && window.tf56.jumpToTMSPage();
  }catch(e){
    console.log(e);
  }
};


// WEBPACK FOOTER //
// ./src/utils/jsBridge.js